import type { RouteRecordRaw } from 'vue-router'

export const temporalClosuresRoutes: RouteRecordRaw[] = [
  {
    name: 'temporalClosures',
    path: '/temporal-closures',
    component: () => import('./views/TemporalClosuresView.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
